import * as React from "react"
import { Link } from "gatsby"

import "../styles/grm-banner.scss"

const GRMbreadcrumbs = (props) => {
    let { uri, title, langCode } = props
    let localTrans = {
        'en': 'Company',
        'es-co': 'Empresa',
        'es-pe': 'Empresa',
        'pt-br': 'Empresa',
    }

    return(
        <aside className="grm-breadcrumbs"
                style={{
                    fontSize: '1rem',
                    margin: '1rem 0 3rem',
                    width: '100%'
                }}>
            <span>{localTrans[langCode]+' > '}</span>
            <Link to={uri} title={title} className="current-page">
                {title}
            </Link>
        </aside>
    )
}

export default GRMbreadcrumbs;
